import t from 'rcm-i18n';
import React, { useCallback } from 'react';
import CartItemsEditable from '../components/CartItemsEditable';
import ConfirmInfo from '../components/ConfirmInfo';
import Totals from '../components/Totals';
import { ContentAreaDisplay } from 'cart-ui/';
import ReceiptPwsSetupLink from '../components/ReceiptPwsSetupLink';
import ReceiptMobileAppLink from '../components/ReceiptMobileAppLink';
import ReceiptOrderConditionMessage from '../components/ReceiptOrderConditionMessage';
import ReceiptSignupInfo from '../components/ReceiptSignupInfo';
import DistributorSignupReceiptMessage from '../components/DistributorSignupReceiptMessage';

interface Props {
  order: any;
  disclaimerMessage: { message: string };
}
const ReceiptPageContainer = ({ order, disclaimerMessage }: Props) => {
    if (localStorage.getItem('isCartV2')) {
        localStorage.removeItem('isCartV2')
      }
    return <div className="appCont paymentPage">
        <div className="container-fluid">
            <div className="receipt-page-ads-container">
                <ContentAreaDisplay areaName="checkoutReceiptTop" />
                <ReceiptPwsSetupLink order={order} />
                <ReceiptMobileAppLink order={order} />
                <ReceiptOrderConditionMessage order={order} />
            </div>
            <DistributorSignupReceiptMessage order={order} />
            <div className="row">
                <div className="col-xs-12">
                    <h1>{t('Order Confirmation')}</h1>
                </div>
            </div>
            <ReceiptSignupInfo order={order} />
            <div className="row">
                <div className="col-xs-12">
                    {t('Order Number')}:&nbsp;
                    <span className="orderNumber">{order.orderNumber}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <ConfirmInfo order={order} />
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 cart-items">
                    <CartItemsEditable orderItems={order.items}
                                       onItemQuantityChange={() => { }}
                                       enableItemEdits={false}
                                       enableItemLinks={false} />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 col-sm-push-6 col-xs-12">
                    <div className="subTotals">
                        <table className="rcmBagDisplaySubTotals">
                            <Totals orderTotals={order.orderTotals} />
                        </table>
                    </div>
                </div>
            </div>
            <div className="col-xs-12">
                <div className="buttons">
                    <a className="button btn btn-default checkout-receipt-print-button"
                       onClick={useCallback(() => { window.print(); }, [])}>
                        {t('Print')}
                    </a>
                </div>
            </div>
            <div>{disclaimerMessage.message}</div>
        </div>
    </div>
};
export default ReceiptPageContainer;
